// extracted by mini-css-extract-plugin
export default {"header_pill":"HeaderGroup_header_pill__H78K1"};